import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_icon, { icon: _ctx.icon }, null, 8, ["icon"]),
      _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
    ]),
    (_ctx.enabled)
      ? (_openBlock(), _createBlock(_component_icon, {
          key: 0,
          icon: "check-square",
          class: "checkbox",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enabled = false))
        }))
      : (_openBlock(), _createBlock(_component_icon, {
          key: 1,
          icon: "square",
          class: "checkbox",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.enabled = true))
        }))
  ]))
}